import {type Dispatch, type SetStateAction, useState} from 'react'

/**
 * Local title state that mirrors `source` while `isEditing` is false. When the
 * user is editing, local writes are preserved and `source` updates are ignored
 * (so a server refresh doesn't overwrite an in-progress edit). When editing
 * ends or `source` changes while not editing, the value resyncs to `source` in
 * the same render.
 */
export function useTitleMirror(source: string, isEditing: boolean): [string, Dispatch<SetStateAction<string>>] {
  const [value, setValue] = useState(source)
  const [prevSource, setPrevSource] = useState(source)
  const [prevIsEditing, setPrevIsEditing] = useState(isEditing)
  if (source !== prevSource || isEditing !== prevIsEditing) {
    setPrevSource(source)
    setPrevIsEditing(isEditing)
    if (!isEditing && value !== source) {
      setValue(source)
      return [source, setValue]
    }
  }
  return [value, setValue]
}
